import React, { useState } from "react"
import styled from "styled-components"
import TitleGroup from './common/TitleGroup'
import TesteGratis from './teste_gratis'
import ArrowDown from './../../svgs/circle_down.svg';

import { news } from './data/news'
const Wrapper = styled.div`
  & + div {
    max-width: 583px;
  }
`

const WrapperContent = styled.div`
  padding-top: 50px;
  & > div {
    max-width: 583px;
  }
    @media(max-width: 919px) {
    display: flex;
    justify-content: center;
  }
` 
const Items = styled.ul`
  list-style: none;
  border-left: 1px solid var(--cSecondary);
  color: var(--cPrimary);
  padding-left: 0;
  margin-top: 50px;
  padding-bottom: 60px;
  margin-bottom: 0;

  @media(max-width: 919px) {
    margin-left: 32px;

  }
`

const ItemsWrapper = styled.div`
  display: grid;

  grid-template-columns: 1fr;
  grid-gap: 1rem;
  @media(min-width: 920px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 3rem;
  }

`

const ItemTitle = styled.h4`
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 1.2rem;
`
const Item = styled.li`
  display: flex;
  position: relative;
  gap: 2rem;
  padding-left: 2rem;
  cursor: pointer;
  & + & {
    margin-top: 3rem;
  }
  i {
    margin-top: 5px;
    color: var(--cSecondary);
    width: 26px;
    font-size: 30px;
    font-weight: 300;
  }

    &::after{
      content: '';
      position: absolute;
      height: 100%;
      border: solid 2px transparent;
      border-radius: 0.2rem;
      left: -2px;
    }
  &[data-current="true"] {
    &::after{
      border-color: var(--cPrimaryLight);
    }
    i, ${ItemTitle} {
      color: var(--cPrimaryLight);
      font-weight: 400;
      
    }
  }
`
const ItemDescription = styled.p`
  font-weight: 300;
  font-size: 1rem;
  line-height: 22px;
  margin-top: 0;
`
const ItemImage = styled.div`
  @media(max-width: 919px) {
  display: none;
  }

  @media(min-width: 920px) {
    transform: translateX(200%);
    transition: all 1s;
    position: absolute;
    height: 541px;
    width: 540px;
    &.show {
    transform: translateX(0);
    }
    &.hide {
      transform: translateX(200%);
    }
  }
  
  &[data-current="true"] {
    display: block;
    
  }
 

`

const Cta = styled.a`
  display: block;
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--cPrimary);
  text-decoration: underline;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 40px;
  i {
    margin-left: 10px;
  }
`

const ButtonWrapper = styled.div`
  display: block;
  margin-top: 30px;
  
  @media(min-width: 920px) {
    margin-top: 540px;
    transform: translateY(-50%);
    margin-left: 40px;

  display: inline-block;
  }
  
`
const ArrowWrapper = styled.div`
  @media(min-width: 920px) {

    transform: translateX(-32px);
  }
`
const LeftWrapper = styled.div`
@media(min-width: 920px) {
  margin-left: 20px;
}
  
`


const Novidades = ({ handle }) => {
  const [current, setCurrent] = useState(news[0].key)
  return (
  <section>
    <div className="container mSection" id="novidades" style={{marginBottom: 0}}>
      <Wrapper>
        <WrapperContent>
          <div>
            <TitleGroup supTitle="Principais novidades do sistema" title="O que há de novo no TagPlus 2.0" icon="far fa-gift">
            <p>Após muitos estudos, testes e escolhas minuciosas de como levar até você, cliente, a melhor versão do nosso sistema, finalmente podemos anunciar a chegada do tão esperado TagPlus 2.0!</p>
            </TitleGroup>
          </div>
          
        </WrapperContent>
        
        <ItemsWrapper>
        <div>
        <Items>
          {news.map(item =>
            <Item key={item.key} data-current={item.key === current} onClick={() => setCurrent(item.key)}>
              <i className={item.icon} />
              <div>
                <ItemTitle>{item.title}</ItemTitle>
                <ItemDescription>{item.description}</ItemDescription>
              </div>
              
            </Item>
          )}
         </Items>
         <ArrowWrapper>
         <ArrowDown />
         </ArrowWrapper>
         
         </div>
         <LeftWrapper>
           <Cta href="//blog.tagplus.com.br/" target="__blank">
            Veja mais nosso blog
            <i className="far fa-chevron-double-right" />
           </Cta>
         {news.map(item =>
            <ItemImage key={`image-${item.key}`} data-current={item.key === current} className={item.key === current ? 'show' : 'hide'}>
              {item.img}
            </ItemImage>
          )}
          <ButtonWrapper>
          <TesteGratis />
          </ButtonWrapper>
         
          </LeftWrapper>
        </ItemsWrapper>
       
      </Wrapper>
     
    </div>
    
  </section>
 
)}
export default Novidades
